<section class="subheader ">
    <img onerror="this.src='./assets/img/default.png'" class="img-title w-100 desk" [src]="path">
    <img onerror="this.src='./assets/img/default.png'" class=" img-title w-100 mob" [src]="pathMob">
    <div class="texto-s container">
        <h1 class="azul">{{title}}</h1>
        <div class='container-carousel-header w-100'>
            <div class="carousel-cell-header " *ngFor="let item of  itemCarrouselHeader;">
                <div id="boton-portada-landing" class='content-carousel-header'>
                    <a [href]="url(item)">{{item.title}}</a>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="agsec1">
    <div class="container">
        <div class='row'>
            <div class='col'>
                <p _ngcontent-c3="" class="fs-16 c-principal breadcump">
                    <ng-container *ngIf='datos.parent'>
                        <span _ngcontent-c3="" id="breadcump">
                            <a [href]="language+'/'+datos.parent[0].systemTitle" class="c-principal">
                                <strong *ngIf='datos.parent'>{{datos.parent[0].title}} &gt; </strong>
                            </a>
                            {{datos.title}}
                        </span>
                    </ng-container>

                    <ng-container *ngIf='!datos.parent'>
                        <span _ngcontent-c3="" id="breadcump">
                            <a [href]="backUrl()" class="c-principal">
                                <strong>{{datos.venueTitle}} &gt; </strong>
                            </a>
                            {{datos.title}}
                        </span>
                    </ng-container>
                </p>
            </div>
        </div>
        <div class="row">
            <div [style.width]="'100%'">
                <!--<app-carrousel-img *ngIf='datos' [data]='datos.gallery' [title]='datos.title'></app-carrousel-img>-->
                <app-galery-img *ngIf='datos' [data]='datos.gallery' [body]='datos.body'
                    [title]='datos.title'></app-galery-img>
            </div>
            <div class="col-md-4" *ngIf='itemsInfo.length > 0'>
                <ul class="list-group">
                    <li class="list-group-item active ">Más información
                    </li>
                    <li *ngFor="let item of itemsInfo" [class.d-none]="item.title === datos.title"
                        class="list-group-item">
                        <a [href]="url(item)">{{item.title}}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</section>